import { type FunctionComponent, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { type State } from "@App/state";
import { Loader } from "@App/Components/Loader";
import type { Role } from "@App/types/ayvens/role";
import type { TokenApi } from "@App/apis/rest/ayvens/token/interfaces";
import { setInitialRole, setInitialToken, setRole, setToken } from "@App/state/reducers/auth";

export type VehicleProps = {
  tokenApi: TokenApi;
};
export const TokenProtectedRoutes: FunctionComponent<VehicleProps> = ({
  tokenApi,
}: VehicleProps) => {
  const [searchParams] = useSearchParams();
  const tokenParam = searchParams.get("jwt");
  const role = useSelector((state: State) => state.auth.role);
  const initialToken = useSelector((state: State) => state.auth.initialToken);
  const token = useSelector((state: State) => state.auth.token);
  const initialRole = useSelector((state: State) => state.auth.initialRole);
  const organization = useSelector((state: State) => state.orders.organization);

  const dispatch = useDispatch();
  const currentLocation = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [errorOccurred, setErrorOccurred] = useState(false);

  useEffect(() => {
    if (tokenParam === null || tokenParam === undefined) {
      dispatch(setRole(null));
      dispatch(setToken(null));
      return;
    }

    !initialToken && dispatch(setInitialToken(tokenParam));

    if (tokenParam !== token) {
      dispatch(setRole(null));

      setErrorOccurred(false);
      dispatch(setToken(tokenParam));

      getTokenInformation(tokenParam);
    }

    setIsLoading(false);
  }, [tokenParam]);

  const getTokenInformation = async (token: string) => {
    try {
      const tokenInfo = await tokenApi.getTokenInformation(token);
      dispatch(setRole(tokenInfo.role as Role));
      !initialRole && dispatch(setInitialRole(tokenInfo.role as Role));
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching token information:", error);
      setErrorOccurred(true);
      setIsLoading(false);
    }
  };

  if ((tokenParam && errorOccurred) || tokenParam === null || tokenParam === undefined) {
    return (
      <Navigate
        to={`/partner/${organization?.slug}/login`}
        state={{ location: currentLocation }}
        replace
      />
    );
  }
  if (isLoading) return <Loader />;
  if (!isLoading && tokenParam && role) {
    return <Outlet />;
  }

  return null;
};
